import { render, staticRenderFns } from "./ChooseShelf.vue?vue&type=template&id=4f454474&scoped=true&"
import script from "./ChooseShelf.vue?vue&type=script&lang=js&"
export * from "./ChooseShelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f454474",
  null
  
)

export default component.exports